import { vars } from '@etg/wings';
import { css, keyframes, cx } from '@eti/styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const spinnerAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;
const wrapperStyles = css`
  position: relative;
`;
const circle = size => css`
  animation: ${spinnerAnimation} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border: calc(${size} / 12) solid;
  border-color: ${vars.colors.decoration.dark} transparent transparent transparent;
  border-radius: 50%;
  box-sizing: border-box;
  display: block;
  height: ${size};
  margin: 6px;
  position: absolute;
  width: ${size};
`;
const spinner = size => css`
  display: inline-block;
  height: calc(${size} + 13px);
  position: relative;
  width: calc(${size} + 13px);
  z-index: 1;
`;
const background = size => css`
  border: calc(${size} / 12) solid #ddd;
  border-radius: 50%;
  box-sizing: border-box;
  height: ${size};
  position: absolute;
  right: 6px;
  top: 6px;
  width: ${size};
`;
const LoadingSpinner = _ref => {
  let {
    size = '50px',
    styles
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: cx(wrapperStyles, styles),
    "data-testid": "loading-spinner",
    children: [/*#__PURE__*/_jsx("div", {
      className: spinner(size),
      children: /*#__PURE__*/_jsx("div", {
        className: circle(size)
      })
    }), /*#__PURE__*/_jsx("div", {
      className: background(size)
    })]
  });
};
export default LoadingSpinner;
//# sourceMappingURL=LoadingSpinner.js.map